import { DEFAULT_TABLE_COLUMNS, MIN_W, MAX_W, MAX_H } from "./constants";

// 날짜/초기값
export const todayISO = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(
    2,
    "0"
  )}-${String(d.getDate()).padStart(2, "0")}`;
};

export const freshValues = () => ({
  title: "",
  dateStr: todayISO(),
  editorHtml: "<p></p>",
  note: "",
  photos: [],
  files: [],
});

// 템플릿 바디 정리(값 비우고 표 rows 비움)
export const sanitizeTemplateBody = (body) => {
  const layout = Array.isArray(body?.layout) ? body.layout : undefined;
  const blocksMeta =
    body?.blocksMeta && typeof body.blocksMeta === "object"
      ? body.blocksMeta
      : undefined;
  const tables =
    body?.tables && typeof body.tables === "object"
      ? Object.fromEntries(
          Object.entries(body.tables).map(([k, t]) => [
            k,
            { columns: t?.columns || DEFAULT_TABLE_COLUMNS, rows: [] },
          ])
        )
      : {};
  return {
    layout,
    blocksMeta,
    values: freshValues(),
    customValues: {},
    tables,
  };
};

// 기타 유틸
export const withConstraints = (it) => ({
  ...it,
  minW: MIN_W,
  maxW: MAX_W,
  maxH: MAX_H,
});
export const parseMaybeJSON = (v) => {
  if (!v) return null;
  if (typeof v === "string") {
    try {
      return JSON.parse(v);
    } catch {
      return null;
    }
  }
  return typeof v === "object" ? v : null;
};

export const newRow = () => ({
  _id: crypto.randomUUID(),
  code: "",
  name: "",
  spec: "",
  unit: "",
  qty: 0,
  price: 0,
  amount: 0,
  remark: "",
});

export const layoutsEqual = (a, b) => {
  if (!a || !b || a.length !== b.length) return false;
  for (let i = 0; i < a.length; i++) {
    const x = a[i],
      y = b[i];
    if (x.i !== y.i || x.x !== y.x || x.y !== y.y || x.w !== y.w || x.h !== y.h)
      return false;
  }
  return true;
};

export const computeRow = (row, cols) => {
  const m = { ...row };
  cols.forEach((c) => {
    if (c.type === "calc" && typeof c.calc === "function")
      m[c.key] = Number(c.calc(m)) || 0;
  });
  return m;
};

export const getBottomY = (lyt) =>
  lyt.reduce((max, l) => Math.max(max, l.y + l.h), 0);

// 이미지 압축
export const compressImage = (file, maxSize = 1600, quality = 0.8) =>
  new Promise((resolve) => {
    const img = new Image();
    const reader = new FileReader();
    reader.onload = () => {
      img.src = reader.result;
    };
    img.onload = () => {
      const scale = Math.min(1, maxSize / Math.max(img.width, img.height));
      const w = Math.round(img.width * scale),
        h = Math.round(img.height * scale);
      const canvas = document.createElement("canvas");
      canvas.width = w;
      canvas.height = h;
      const ctx = canvas.getContext("2d");
      ctx.drawImage(img, 0, 0, w, h);
      resolve(canvas.toDataURL("image/jpeg", quality));
    };
    reader.readAsDataURL(file);
  });
